import React, {useContext} from 'react';
import {TabbedOverviewPage, ScoreStructureSection, ReadinessSolutionScoresSection} from '../components/OverviewSections.comp';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

const AboutScoresPage = () => {
    const {authUser} = useContext(AuthContext);
    const stage = getPlanStage(authUser);

    // Per the plan-visibility sheet: "COS Readiness Solution Scores" is
    // P1-only; "COS Children Assessment Scores" is P0+P1. Not on the sheet
    // (LC) gets neither tab hidden with a fallback — only the one tab it's
    // confirmed for stays, same as the P0 behavior today.
    const tabs = [
        ...(stage === 'P1' ? [{label: 'COS Readiness Solution Scores', content: <ReadinessSolutionScoresSection/>}] : []),
        {label: 'COS Children Assessment Scores', content: <ScoreStructureSection/>},
    ];

    return <TabbedOverviewPage skipNoDataGate tabs={tabs}/>;
};

export default AboutScoresPage;
